import * as dayjs from 'dayjs';
import * as updateLocale from 'dayjs/plugin/updateLocale';
import { GlobalConstants } from '../constant/constant';
dayjs.extend(updateLocale);
const localeObject = {
  name: 'se-time',
  weekStart: GlobalConstants.START_OF_WEEK, // sets Saturday as start of week
};
dayjs.updateLocale('en', localeObject);

export class WorkWeek {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;

  constructor(targetDate: dayjs.Dayjs) {
    this.startDate = targetDate.startOf('week');
    this.endDate = targetDate.endOf('week');
  }

  static getCurrentWorkWeek() : WorkWeek {
    return new WorkWeek(dayjs());
  }

  getPreviousWorkWeek() : WorkWeek {
    return new WorkWeek(this.startDate.add(-1, 'week'))
  }
}

